module.exports = __webpack_public_path__ + "static/06-fz-zoom-e94f0ea12baf768579220a4365965a81.jpg";